export function withTenantSchema(
  headers: Record<string, string | undefined | null> = {},
): Record<string, string> {
  const normalizedHeaders = Object.fromEntries(
    Object.entries(headers).filter(([, value]) => typeof value === 'string' && value.length > 0),
  ) as Record<string, string>

  const schema = import.meta.env.VITE_SCHEMA?.trim()

  if (schema) {
    normalizedHeaders['X-Tenant-Schema'] = schema
  }

  return normalizedHeaders
}
